module.exports = __webpack_public_path__ + "static/img/WeChat_lgo_icon1.ee413cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WeChat_lgo_icon1.svg
// module id = zjXj
// module chunks = 1